import * as React from "react";
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { FormGroup, FormControl } from "react-bootstrap";
import { EstadoReciboSAT } from "../../config_general_recibo/modelo/EstadoReciboSAT";

export class ModalCambioEstado extends React.Component<ModalCambioEstadoProps, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            show: true,
            observacion: '',
            estado: 0
        };
    }

    render() {
        const btnAcciones = [
            (
                <FlatButton key={1}
                    label={"CAMBIAR ESTADO"}
                    disabled={(this.state.estado === 0 || this.state.observacion.length <= 0)}
                    onClick={() => {
                        if (this.state.estado !== 0 && this.state.observacion.length > 0) {
                            this.handleClose();
                            this.props.obtenerDatosCambioEstado(this.state.estado, this.state.observacion);
                        }
                    }} />
            ), (
                <FlatButton key={0}
                    label="Cerrar"
                    onClick={() => this.handleClose()} />
            )
        ];
        return (
            <div>
                <Dialog title={"Cambio Estado Notificaciones Recibidas SAT"}
                    actions={btnAcciones}
                    contentStyle={{ width: '40%', maxWidth: 'none' }}
                    autoScrollBodyContent
                    open={this.state.show}
                    onRequestClose={() => this.handleClose()}
                    modal={false}>
                    {this.renderContenidoGestion()}
                </Dialog>
            </div>
        );
    }

    renderContenidoGestion() {
        return (
            <div>
                <div className="modal-form-text">
                    <label><b>Observación cambio de estado</b></label>
                    <Divider />
                    <br />
                </div>
                <div>
                    <div className="modal-form-text info-col" style={{ marginBottom: '25px' }}>
                        <span>
                            El estado se actualizara para los registros seleccionados con la observación ingresada.
                        </span>
                    </div>
                    <FormGroup controlId="formControlsTextarea" validationState={this.getValidationState()}>
                        <FormControl
                            value={this.state.estado}
                            onChange={e => this.setState({ estado: e.target.value })}
                            componentClass="select">
                            <option key={0} value={0}>Seleccione...</option>
                            {EstadoReciboSAT.map(estado => (<option key={estado.codigo} value={estado.codigo}>{estado.nombre}</option>))}
                        </FormControl>
                        <br/>
                        <FormControl
                            value={this.state.observacion}
                            onChange={e => this.setState({ observacion: e.target.value })}
                            componentClass="textarea"
                            placeholder="Observación"
                            style={{ height: 130 }} maxLength={256}
                        />
                    </FormGroup>
                </div>
            </div>
        );
    }

    getValidationState() {
        const length = this.state.observacion.length;
        const estado = this.state.estado !== 0;
        return (length > 0 && estado) ? 'success': 'error';
    }

    handleClose() {
        this.setState({ show: false });
        this.props.cerrarModal();
    }
}

interface ModalCambioEstadoProps {
    obtenerDatosCambioEstado: (estado: number, observacion: string) => void,
    cerrarModal: () => void
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_detalle/componentes/ModalCambioEstado.tsx